import React, { useMemo } from 'react'
import { useQueryParam, StringParam } from 'use-query-params'

import { Subheader } from '@app/components'
import { LntTabs } from '@app/components/base'

import { QUERY_PARAMS_KEY } from '@app/constants'

import classNames from 'classnames'

import styles from './styles.module.scss'

import type { ReactNode } from 'react'
import type { TabsLayoutProps } from './types'

export const TabsLayout: React.FC<TabsLayoutProps> = ({
  className: outerClassName,
  tabs,
  tabToolbars,
  fallbackSubheaderToolbar
}) => {
  const [tabQuery, setTabQuery] = useQueryParam(QUERY_PARAMS_KEY.tab, StringParam, { updateType: 'push' })

  const className = classNames(outerClassName, styles.tabsLayout__tabs)
  const key = useMemo<string | undefined>(() => tabQuery ?? tabs[0]?.key, [tabQuery])
  const content = useMemo<ReactNode | undefined>(() => tabs?.find(tab => tab.key === key)?.content, [key])

  const handleTabClick = (activeKey: string): void => {
    const isFirstTab = tabs[0]?.key === activeKey
    const tabQuery = isFirstTab ? null : activeKey

    setTabQuery(tabQuery)
  }

  const toolbar = useMemo(() => {
    if (tabToolbars && key) return tabToolbars[key]

    return fallbackSubheaderToolbar
  }, [key, tabToolbars, fallbackSubheaderToolbar])

  return (
    <section className={ styles.tabsLayout }>
      <Subheader
        className={ className }
        toolbarClassName={ styles.tabsLayout__toolbar }
        toolbar={ toolbar }
        control={
          <LntTabs
            activeKey={ key }
            items={ tabs }
            onTabClick={ handleTabClick }
          />
        }
      />

      { content }
    </section>
  )
}
